module.exports = __webpack_public_path__ + "img/arrow_right_alt_black.91c1d615.svg";